import { Box, Button, Typography } from "@mui/material"
import { BreadCrumb, SnackSimple } from "../../../../../../components"
import { useTranslation } from "react-i18next"
import { useStyles } from "./styles"
import Loader from "../../../../../../components/loader"
import { useParams } from "react-router-dom"
import { DinamicForm } from "../../../../../../components/dinamicForm"
import { useBody } from "./body"
import CatalogOption from "./components/catalogOption"
import { useCatalogStoreModule } from "./components/catalogOption/context"
import { LoadingButton } from "@mui/lab"
import SimpleModal from "../../../../../../components/modal/simpleModal"

const FormCatalog = () => {
  const styles = useStyles()
  const { t } = useTranslation()
  const { items, setProviders, setSubCatalog, setItems, setItemsFromEndpoint, itemsFromEndpoint } = useCatalogStoreModule();
  const { id } = useParams()
  const body = useBody({ setProviders, items, setSubCatalog, id, setItems, setItemsFromEndpoint, itemsFromEndpoint });


  return (
    <Box sx={styles.container}>
      {body.loader && <Loader />}
      {!body.loader && (<>
        <BreadCrumb
          removeBreadcrumb={['report-folio']}
          replaceLabels={{ editEdit: 'editCatalog', create: 'createCatalog' }}
        />

        <Box sx={styles.body}>
          <Typography variant="title_grey_big">{t(`catalog.form.${id ? 'updateTitle' : 'createTitle'}`)}</Typography>

          <Box sx={styles.containerForms}>
            <Box sx={{ width: '400px' }}>
              <DinamicForm input={Object.values(body.inputCrud)} onChange={body.onChangeCrud} values={body.dataCrud} />
            </Box>
            <Box className="child">
              <DinamicForm errors={body.paginationMain.errors} input={Object.values(body.inputFilter)} values={body.paginationMain.filterData} onChange={body.paginationMain.onChange} filter={false} legacyErrors />
            </Box>
          </Box>

          <CatalogOption children={body.filteredItems} level={1} depth={1} id="1" showText={!!body.paginationMain.filterData.search} />

          <Box sx={styles.buttonsContainer}>
            <Button onClick={() => { body.handleCancel() }}>
              {t('catalog.button.cancel')}
            </Button>
            <LoadingButton loading={body.btnLoading} disabled={body.handleDisabled()} className="next" variant="contained" onClick={() => { body.handleAllSubmit() }}>
              {t('catalog.button.save')}
            </LoadingButton>
          </Box>
        </Box>
      </>)}

      <SimpleModal
        open={!!body.modal.open}
        next={body.modal.confirm}
        back={body.closeModal}
        close={body.closeModal}
        description={body.modal.description}
        buttonText={body.modal.butonNext}
        cancelText={body.modal.butonCancel}
        title={body.modal.title}
        loadingButton
        isLoading={body.btnLoading}
      />

      <SnackSimple
        close={body.closeOpenSnakbar}
        open={body.openSnackbar.open}
        type={body.openSnackbar.type}
        message={body.openSnackbar.message}
      />
    </Box>
  )
}

export { FormCatalog }
